import {KeyboardEvent} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {BrandCoinIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {useABTest} from "@pg-mono/ab-testing";

import {abTestingInstance} from "../../ab_testing/ab_testing_instance";
import {HidePricesVariant, OngoingABTests} from "../../ab_testing/ongoing_ab_tests";
import {AuthModalVariant} from "../../auth/components/auth_modal/AuthModalHeaderVariants";
import {openAuthModal} from "../../auth/store/auth_modal_slice";
import {useAppDispatch} from "../../store/hooks";
import {UserSource} from "../../tracking/tracking_utils/user_source";

const hidePricesAbTestInstance = abTestingInstance.getABTestContainerProps(OngoingABTests.HIDE_PRICES_AND_REGISTER);

export const TopHiddenPricesBanner = () => {
    const dispatch = useAppDispatch();
    const {abTestVariant} = useABTest(hidePricesAbTestInstance);
    const shouldShowHiddenPricesBanner = abTestVariant === HidePricesVariant.HIDDEN;

    if (!shouldShowHiddenPricesBanner) {
        return null;
    }

    const handleButtonClick = () => {
        dispatch(
            openAuthModal({
                userSource: UserSource.HIDDEN_PRICES_BANNER,
                headerVariant: AuthModalVariant.HIDDEN_PRICES,
                modalVariant: "extended"
            })
        );
    };

    const handleBannerKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            handleButtonClick();
        }
    };

    const handleContentWrapperClick = () => {
        handleButtonClick();
    };

    return (
        <div className={wrapperStyle}>
            <div className={contentWrapperStyle} onClick={handleContentWrapperClick} onKeyDown={handleBannerKeyDown} role="button" tabIndex={0}>
                <div className={contentStyle}>
                    <BrandCoinIcon size="12.4" wrapperSize="12.4" wrapperColor="var(--colors-primary)" />

                    <Text as="div" variant="headline_1" className={textStyle}>
                        Załóż konto, aby <strong>odkryć ceny</strong> wszystkich ofert
                    </Text>
                </div>

                <Button className={buttonStyle} size="big" variant="filled_primary">
                    Odkryj ceny
                </Button>
            </div>
        </div>
    );
};

const wrapperStyle = css({
    backgroundColor: "var(--colors-info)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    userSelect: "none"
});

const contentWrapperStyle = css({
    display: "flex",
    cursor: "pointer",
    md: {
        maxWidth: "139rem",
        flexDirection: "row",
        paddingX: 4,
        columnGap: 4,
        alignItems: "center"
    }
});

const contentStyle = css({
    display: "flex",
    alignItems: "center",
    columnGap: 5,
    flex: 1,
    flexDirection: "column",
    rowGap: 2,
    textAlign: "center",

    md: {
        flexDirection: "row",
        textAlign: "left"
    }
});

const textStyle = css({
    fontWeight: 400,
    fontSize: "2.4rem",
    lineHeight: "3.2rem",

    md: {
        fontSize: "4.2rem",
        lineHeight: "5.2rem"
    }
});

const buttonStyle = css({
    minWidth: "100%",
    flexShrink: 0,

    md: {
        minWidth: "35rem"
    }
});
import {KeyboardEvent} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {BrandCoinIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {useABTest} from "@pg-mono/ab-testing";

import {abTestingInstance} from "../../ab_testing/ab_testing_instance";
import {HidePricesVariant, OngoingABTests} from "../../ab_testing/ongoing_ab_tests";
import {AuthModalVariant} from "../../auth/components/auth_modal/AuthModalHeaderVariants";
import {openAuthModal} from "../../auth/store/auth_modal_slice";
import {useAppDispatch} from "../../store/hooks";
import {UserSource} from "../../tracking/tracking_utils/user_source";

const hidePricesAbTestInstance = abTestingInstance.getABTestContainerProps(OngoingABTests.HIDE_PRICES_AND_REGISTER);

export const TopHiddenPricesBanner = () => {
    const dispatch = useAppDispatch();
    const {abTestVariant} = useABTest(hidePricesAbTestInstance);
    const shouldShowHiddenPricesBanner = abTestVariant === HidePricesVariant.HIDDEN;

    if (!shouldShowHiddenPricesBanner) {
        return null;
    }

    const handleButtonClick = () => {
        dispatch(
            openAuthModal({
                userSource: UserSource.HIDDEN_PRICES_BANNER,
                headerVariant: AuthModalVariant.HIDDEN_PRICES,
                modalVariant: "extended"
            })
        );
    };

    const handleBannerKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            handleButtonClick();
        }
    };

    const handleContentWrapperClick = () => {
        handleButtonClick();
    };

    return (
        <div className={wrapperStyle}>
            <div className={contentWrapperStyle} onClick={handleContentWrapperClick} onKeyDown={handleBannerKeyDown} role="button" tabIndex={0}>
                <div className={contentStyle}>
                    <BrandCoinIcon size="12.4" wrapperSize="12.4" wrapperColor="var(--colors-primary)" />

                    <Text as="div" variant="headline_1" className={textStyle}>
                        Załóż konto, aby <strong>odkryć ceny</strong> wszystkich ofert
                    </Text>
                </div>

                <Button className={buttonStyle} size="big" variant="filled_primary">
                    Odkryj ceny
                </Button>
            </div>
        </div>
    );
};

const wrapperStyle = css({
    backgroundColor: "var(--colors-info)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    userSelect: "none"
});

const contentWrapperStyle = css({
    display: "flex",
    cursor: "pointer",
    md: {
        maxWidth: "139rem",
        flexDirection: "row",
        paddingX: 4,
        columnGap: 4,
        alignItems: "center"
    }
});

const contentStyle = css({
    display: "flex",
    alignItems: "center",
    columnGap: 5,
    flex: 1,
    flexDirection: "column",
    rowGap: 2,
    textAlign: "center",

    md: {
        flexDirection: "row",
        textAlign: "left"
    }
});

const textStyle = css({
    fontWeight: 400,
    fontSize: "2.4rem",
    lineHeight: "3.2rem",

    md: {
        fontSize: "4.2rem",
        lineHeight: "5.2rem"
    }
});

const buttonStyle = css({
    minWidth: "100%",
    flexShrink: 0,

    md: {
        minWidth: "35rem"
    }
});
